import { useMutation } from '@tanstack/react-query';
import { registerVideoSessionFetcher } from 'src/lib/fetchers/video-player-fetcher';

type UseRegisterVideoSessionType = {
  watchStatsRegisterSessionMutate: ReturnType<typeof useMutation>['mutate'];
  isLoading: boolean;
  error: unknown;
  registerVideoSessionData: string | null;
};

const useWatchStatsRegisterSession = (): UseRegisterVideoSessionType => {
  const { data, isLoading, error, mutate } = useMutation(
    ['register-session'],
    registerVideoSessionFetcher,
    {
      retry: false,
    },
  );
  return {
    registerVideoSessionData: data?.data?.publicKey || null,
    isLoading,
    error,
    watchStatsRegisterSessionMutate: mutate,
  };
};

export default useWatchStatsRegisterSession;
